$( document ).ready(function () {

    // function used for enable/disable of takeaway vat input fields after user's action
    function enableOrDisableInputFields(state) {
        if (state) {
            $('#include_takeaway_vat')[0].checked = true;
            $('#takeaway_meals_vat')[0].disabled = false;
            $('#takeaway_drinks_vat')[0].disabled = false;
        } else {
            $('#include_takeaway_vat')[0].checked = false;
            $('#takeaway_meals_vat')[0].disabled = true;
            $('#takeaway_drinks_vat')[0].disabled = true;
        }
    }

    $('body').on('change', '.country-for-restaurant-spec', function(e, a) {
        $.ajax({
            url: ('/profile/business-information/vat-settings-for-country'),
            type: 'post',
            data: {
                country: $('.country-for-restaurant-spec')[0].value
            },
            success: function(data) {
                $('#inhouse_meals_vat')[0].value = data['inhouse_meals_vat'];
                $('#inhouse_drinks_vat')[0].value = data['inhouse_drinks_vat'];
                $('#takeaway_meals_vat')[0].value = data['takeaway_meals_vat'];
                $('#takeaway_drinks_vat')[0].value = data['takeaway_drinks_vat'];
                $('.currency-dropdown').find('li a[data-value=' + data['currency'] + ']').trigger('clicked');
                var state = false;
                if (data['show_takeaway_vat']) {
                    state = true;
                }
                enableOrDisableInputFields(state);
            },
        });
    });

    $('body').on('click', '#include_takeaway_vat', function() {
        enableOrDisableInputFields($('#include_takeaway_vat')[0].checked);
    });
});